// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing-interval-toggle[data-v-4731b825]{white-space:nowrap}.commitment-ack-panel[data-v-4731b825]{background-color:#f6f6f6;border:1px solid #c6c6c6;border-radius:.25rem;padding:.75rem;cursor:pointer;margin-bottom:0}.commitment-ack-text[data-v-4731b825]{flex:1 1 auto;min-width:0}", ""]);
// Exports
module.exports = exports;
